import { Controller, useFormContext } from 'react-hook-form';
import { FormLabel } from '../FormLabel';

interface CheckboxFieldProps {
  label: string;
  name: string;
  disabled?: boolean;
  validate?: (value: string) => boolean | string;
  testId?: string;
  isRequired?: boolean;
}
function CheckboxField({ label, validate, name, isRequired = false, disabled = false, testId }: CheckboxFieldProps) {
  const { control } = useFormContext(); // retrieve all hook methods

  return (
    <FormLabel label={label}>
      <div className="w-full lg:w-1/2">
        <Controller
          name={name}
          control={control}
          rules={{
            required: isRequired ? 'This is required' : false,
            validate,
          }}
          render={({ field: { onChange, value }, fieldState: { error } }) => {
            return (
              <>
                <input
                  data-cy={testId}
                  disabled={disabled}
                  onChange={(event) => (onChange ? onChange(event.target.checked) : null)}
                  checked={value || false}
                  id="checked-checkbox"
                  type="checkbox"
                  // eslint-disable-next-line max-len
                  className="w-4 h-4 text-primary-300 bg-gray-100 border-gray-300 rounded "
                />

                <div className="mt-2 text-sm text-error-600 dark:text-green-500">
                  <span className="font-medium">{error?.message}</span>
                </div>
              </>
            );
          }}
        />
      </div>
    </FormLabel>
  );
}

export { CheckboxField };
